<script setup lang="ts">
import { inject } from 'vue'
import { VyzvaSpecificationPublicResponse } from '/@src/client-public'
export interface UkazovateleProjektuProps { }

const props = defineProps<UkazovateleProjektuProps>()

const specResponse = inject('specResponse') as VyzvaSpecificationPublicResponse
const ukazovateleData = specResponse.zoppmSpec!.monitorovaneUkazovatele!.filter(
  (ukazovatel) => !ukazovatel.casZneplatnenia
)
</script>

<template>
  <template v-for="(ukazovatel, key) in ukazovateleData" :key="key">
    <Ukazovatel :ukazovatel="ukazovatel" :idx="key" />
  </template>
</template>

<style lang="scss"></style>
